module.exports = __webpack_public_path__ + "static/grant_customer_access_form-3c96ee529904cb8977128da46533a7f5.png";